<lib-contact
  [labels]="'lib.contact' | translate"
  [theme]="theme"
  [contactImg]="imageSrc"
  [imgText]="'homePage.contact.imgText' | translate"
  [buttonLabel]="'homePage.contact.buttonLabel' | translate"
  [title]="'homePage.contact.title' | translate"
  [text]="'homePage.contact.address' | translate"
  [title1]="'homePage.contact.title1' | translate"
  [text1]="text1"
  [title2]="'homePage.contact.title2' | translate"
  [text2]="text2"
  [buttonLabel1]="'homePage.contact.buttonLabel1' | translate"
  [buttonLabel2]="'homePage.contact.buttonLabel2' | translate"
  (firstButtonClicked)="openLocation()"
  (secondButtonClicked)="sendEmail()"
  (thirdButtonClicked)="onCallWissal()"
></lib-contact>
